export default __webpack_public_path__ + "static/media/mayu_icon.e3ffdbbf.png";